import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Vuex from 'vuex';
import Vue from 'vue';
import 'dayjs/locale/ru'

import api from '../../../admin/api/api';

dayjs.extend(utc);
dayjs.locale('ru');
Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		startDate: dayjs().startOf('week'),
		chosenDate: dayjs().startOf('day'),
		activeTimePeriod: null,
		disabled: true,
        appointmentsType: window.laravel.appointmentsTypes ? window.laravel.appointmentsTypes.clinic : 1,
		startTime: dayjs().startOf('day').format('HH:mm'),
		endTime: dayjs().endOf('day').format('HH:mm'),
		cells: [],
        appointments: [],
		touchedCells: [],
        userTimeZone: window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone,
        userTimeZoneOffset: window.laravel.userTimeZoneOffset,
        userTimeZoneName: window.laravel.userTimeZoneName,
        userId: window.laravel.user,
        firstAppointmentDate: '',
        doctorId: window.laravel.doctorId,
		config: {
			long: 30,
			startTime: '00:00',
			endTime: '24:00',
		},
		showModal: true,
        doctor: window.laravel.doctor,
		consultation: {
			price: 10,
			time: '00:00',
			start_at: '00:00',
			end_at: '00:00'
		},
		access: window.laravel.access,
		dateNow: dayjs(new Date().toLocaleString("en-US", {timeZone: window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone})),
		windowWidth: window.innerWidth,
        firstAppointmentPeriod: [],
        appointmentsClinicFreeCount: window.laravel.appointmentsClinicFreeCount,
        appointmentsOnlineFreeCount: window.laravel.appointmentsOnlineFreeCount,
        selectAllButton: true,
        inProcessTypePay: window.laravel.inProcessTypePay
	},
	getters: {
		getChosenCells: state => state.touchedCells.filter(cell => cell.chosen === true && !cell.appointment),
		getCanceledCells: state => state.touchedCells.filter(cell => cell.chosen === false && cell.appointment),
		filterCells: state => state.cells.filter(cell => cell.start_at.isSame(state.chosenDate, 'day') && cell.appointment),
		popupCell: state => state.cells.find(cell => cell.showPopup === true),
		dates: state => {
			const dates = [];

			for (let i = 0; i < 7; i++) {
			    if(state.access === 'doctor') {
                    dates.push(state.startDate.startOf('week').add(i, 'day'));
                } else {
                    dates.push(state.startDate.add(i, 'day'));
                }
			}

			return dates;
		},
		times: state => {
			const minutes = dayjs(state.endTime, 'HH:mm').diff(dayjs(state.startTime, 'HH:mm'), 'minute') + 1;

			const times = [];
			let time = dayjs(state.startTime, 'HH:mm');

			if (minutes / state.config.long > 1) {
                for (let i = 0; i < minutes / state.config.long; i++) {
                    if (i > 0) {
                        time = time.add(state.config.long, 'minute');
                    }

                    times.push(time);
                }
            }

			return times;
		},
		timePeriods: state => {
			const timePeriods = [];
			const periods = 4;
			const minutes = dayjs(state.config.endTime, 'HH:mm').diff(dayjs(state.config.startTime, 'HH:mm'), 'minute') + 1;
			let time = dayjs(state.config.startTime, 'HH:mm');

			for (let i = 0; i < periods; i++) {
				let startAt = time.clone();
				time = time.add(parseInt(minutes / periods), 'minute');

				timePeriods.push({
					start_at: startAt,
					end_at: time.subtract(state.config.long, 'minute'),
				});
			}

			timePeriods.push({
				start_at: dayjs(state.config.startTime, 'HH:mm'),
				end_at: dayjs(state.config.endTime, 'HH:mm').subtract(state.config.long, 'minute'),
			});

			return timePeriods;
		},
        getFreeCells: state => {
		    if(state.appointmentsType === window.laravel.appointmentsTypes.clinic){
                return state.appointmentsClinicFreeCount > 0;
            }

            if(state.appointmentsType === window.laravel.appointmentsTypes.online){
                return state.appointmentsOnlineFreeCount > 0;
            }
        },
	},
	mutations: {
		setStartDate(state, startDate) {
			state.startDate = startDate;
        },
		setChosenDate(state, chosenDate) {
			state.chosenDate = chosenDate;
		},
		setActiveTimePeriod(state, activeTimePeriod) {
			state.activeTimePeriod = activeTimePeriod;

			state.startTime = dayjs(activeTimePeriod.start_at).format('HH:mm');
			state.endTime = dayjs(activeTimePeriod.end_at).format('HH:mm');
		},
		setDisabled(state, disabled) {
			state.disabled = disabled;

			state.cells.forEach((cell) => {
				cell.disabled = cell.start_at.isBefore(state.dateNow) ? true : disabled;

				if (!disabled && cell.appointment) {
					cell.chosen = !!cell.appointment;
				}

				if(cell.start_at.isAfter(state.dateNow) && !cell.appointment) {
                    state.notCheckedCells = false;
                }
			});
		},
        setDisabledCell(state, chosenCell) {
            state.cells.forEach((cell) => {
                let find = cell.start_at.toString() === chosenCell.start_at.toString();

                if (find) {
                    cell.disabled = find;

                    cell.chosen = !!cell.appointment;
                }
            });
        },
		setCells(state, cells) {
			state.cells = cells;
		},
        setFirstAppointmentDate(state, appointment) {
		    state.firstAppointmentDate = appointment;
        },
        setFirstAppointmentPeriod(state, firstAppointmentPeriod) {
            state.firstAppointmentPeriod = firstAppointmentPeriod;
        },
		setAppointments(state, {appointments}) {
            state.appointments = appointments;
            state.selectAllButton = true;

            appointments.forEach((appointment) => {
            	appointment.start_at = dayjs.createFromTimezone(appointment.start_at, state.userTimeZone);
                appointment.end_at = dayjs.createFromTimezone(appointment.end_at, state.userTimeZone);
            });

            state.cells.forEach((cell) => {
                Vue.set(cell, 'appointment', appointments.find(appointment => appointment.start_at.isSame(cell.start_at)));

                if (cell.appointment) {
					if (!state.disabled) {
						cell.chosen = !!cell.appointment;
					}

					if (cell.appointment.consultation) {
						cell.appointment.consultation.start_at = dayjs.createFromTimezone(cell.appointment.consultation.start_at, state.userTimeZone);
						cell.disabled = false;
						cell.booked = true;
					}
				}

                if (!state.disabled && state.touchedCells.filter(filterCell => filterCell.chosen === false).find(touchedCell => dayjs.createFromTimezone(touchedCell.start_at, state.userTimeZone).isSame(cell.start_at))) {
                    Vue.set(cell, 'chosen', false);
                }

                if (!state.disabled && state.touchedCells.filter(filterCell => filterCell.chosen === true).find(touchedCell => dayjs.createFromTimezone(touchedCell.start_at, state.userTimeZone).isSame(cell.start_at))) {
                    Vue.set(cell, 'chosen', true);
                }

                if (!cell.appointment && !cell.start_at.isBefore(state.dateNow)) {
                    if (!cell.chosen) {
                        state.selectAllButton = false;
                    } else {
                        state.selectAllButton = true;
                    }
                }
			});
		},
		chooseCell(state, cellToChose) {
			const cell = state.cells.find(cell => cell.start_at === cellToChose.start_at);
			cell.chosen = !cell.chosen;

			cell.type = state.appointmentsType;
            state.selectAllButton = false;
        },
		chooseAllCells(state, chosen) {
			state.cells.forEach((cell) => {
				if (cell.chosen !== chosen && cell.start_at > state.dateNow.add(30, 'minute') ) {
					cell.chosen = chosen;
					cell.type = state.appointmentsType;
				}
			});
            state.selectAllButton = !state.selectAllButton;
		},
		makeAppointment(state, cellToChose) {
			state.consultation.time = cellToChose.start_at.format('dd, DD MMM HH:mm');
			state.consultation.start_at = cellToChose.start_at.format();
			state.consultation.end_at = cellToChose.end_at.format();
		},
		showPopupInfo(state, cellToChose) {
			const cell = state.cells.find(cell => cell.showPopup === true);
			if (cell) {
				Vue.set(cell, 'showPopup', false);
			}

			const cellShow = state.cells.find(cell => cell.start_at === cellToChose.start_at);
			Vue.set(cellShow, 'showPopup', true);
		},
        setAppointmentsType(state, type) {
            state.appointmentsType = type;
        },
		closePopupInfo(state, cellToChose) {
			const cellShow = state.cells.find(cell => cell.start_at === cellToChose.start_at);
			Vue.set(cellShow, 'showPopup', false);
		},
		addTouchedCells(state) {
			state.touchedCells = state.touchedCells.concat(
				state.cells.filter(cell => cell.chosen !== null && !state.touchedCells.find(cellFind => cell.start_at === cellFind.start_at))
			);
		},
		setWindowWidth(state) {
			state.windowWidth = window.innerWidth;
		},
	},
	actions: {
		generateCells: ({state, commit, getters}) => {
			const cells = [];

			commit('addTouchedCells');
			commit('setCells', []);
			commit('setChosenDate', state.startDate);

            api.get('/api/schedule/' + state.doctorId, {appointmentsType: state.access !== 'doctor' ? state.appointmentsType : null})
				.then((response) => {
                    getters.times.forEach((time) => {
						getters.dates.forEach((date) => {
							let newCell = {
								start_at: date.startOf('day').add(time.hour(), 'hour').add(time.minute(), 'minute'),
								chosen: null,
								disabled: state.disabled,
                                consultation: null,
								booked: null,
							};

							newCell.disabled = newCell.start_at.isBefore(state.dateNow.add(30, 'minute')) ? true : newCell.disabled;
							newCell.end_at = newCell.start_at.add(state.config.long, 'minute');

							cells.push(newCell);
						});
					});

					commit('setCells', cells);
					commit('setAppointments', response.data);
				})
				.catch((error) => {
					alert(error);
				});
		},
		saveSchedule: ({state, commit, getters, dispatch}) => {
			commit('addTouchedCells');

			let added = [];
			let canceled = [];

            _.cloneDeep(getters.getChosenCells).forEach((chosenCell) => {
                chosenCell.start_at = dayjs.toStringWithoutTimezone(chosenCell.start_at);
                chosenCell.end_at = dayjs.toStringWithoutTimezone(chosenCell.end_at);

                added.push(chosenCell);
            });

            _.cloneDeep(getters.getCanceledCells).forEach((canceledCell) => {
                canceledCell.start_at = dayjs.toStringWithoutTimezone(canceledCell.start_at);
                canceledCell.end_at = dayjs.toStringWithoutTimezone(canceledCell.end_at);

                canceled.push(canceledCell);
            });

			api.update('/api/schedule/' + state.doctorId, {added: added, canceled: canceled, userId: state.userId})
				.then((response) => {
					commit('setDisabled', true);
					commit('chooseAllCells', null);
					commit('setAppointments', response.data);
				})
				.catch((error) => {
					alert(error);
				});
		},
		makeAppointment: ({state, commit}, {selectedPatient: selectedPatient, anonym: anonym}) => {
			api.post('/api/schedule/make-appointment/' + state.doctorId, {
				start_at: state.consultation.start_at,
				end_at: state.consultation.end_at,
				patient_id: selectedPatient,
                anonym: anonym
			})
                .then((response) => {
                    commit('setAppointments', response.data);

                    window.location.href = "/account/dashboard";
                })
                .catch(error => {
                    ErrorAlert.$emit('errorMessage', 'Извините, но это время недоступно. Пожалуйста, выберите другое время.');
                    ErrorAlert.$on('messageClose', () => window.location.reload());
                });
            state.showModal = false;
        },
        paymentAppointment: ({state, commit}, {cell: cell, selectedPatient: selectedPatient, anonym: anonym}) => {
            const params = new URLSearchParams({
                start_at: state.consultation.start_at,
                end_at: state.consultation.end_at,
                doctor_id: state.doctorId,
                patient_id: selectedPatient,
                anonym: anonym
            });

            commit('closePopupInfo', cell);

            commit('setDisabledCell', cell);

            window.location.href = `/schedule/payment-appointment?${params.toString()}`;
        },
        getFirstAppointmentDate: ({state, commit}) => {
            api.post('/api/schedule/first-appointment/' + state.doctorId, {
                appointmentsType: state.access !== 'doctor' ? state.appointmentsType : null
            }).then((response) => {
                commit('setFirstAppointmentDate', dayjs.createFromTimezone(response.data.firstAppointmentStartAt, state.userTimeZone));
            });
        },
        getFirstAppointmentPeriod: ({state, commit, getters}) => {
            api.post('/api/schedule/first-appointment/' + state.doctorId, {
                appointmentsType: state.access !== 'doctor' ? state.appointmentsType : null
            }).then((response) => {
                let periodIndex = null;
                let dateFirstTime = null;

                if (state.access === 'doctor') {
                    dateFirstTime = dayjs().minute() > 30 ? state.dateNow.add(30, 'minute').format( 'HH:mm') : state.dateNow.format( 'HH:mm');
                } else {
                    dateFirstTime = response.data.firstAppointmentStartAt ? dayjs.createFromTimezone(response.data.firstAppointmentStartAt, state.userTimeZone).format( 'HH:mm') : state.dateNow.format( 'HH:mm');
                }

                getters.timePeriods.forEach(function(item, i, arr) {

                    let itemStartAt = dayjs(item.start_at).format( 'YYYY-MM-DD');
                    let dateFirstPeriod = dayjs(itemStartAt+' '+dateFirstTime);

                    if ((item.start_at.isBefore(dateFirstPeriod)
                        || item.start_at.isSame(dateFirstPeriod))
                        && (item.end_at.isAfter(dateFirstPeriod)
                        || item.end_at.isSame(dateFirstPeriod))
                        && periodIndex === null){

                        periodIndex = i;
                    }
                });

                if (periodIndex === null) {
                    periodIndex = getters.timePeriods.length - 1;
                }

                commit('setFirstAppointmentPeriod', getters.timePeriods[periodIndex]);
            });
        }
    },
});

